import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import linkedGoalsQueryParameters from './src/ui/__generated__/LinkedGoalsQuery$parameters';

export const softwareGoalsEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-atlas-goals-entrypoint" */ './src/ui'),
	),
	getPreloadProps: ({ tenantContext: { cloudId }, context: { match } }: EntryPointRouteParams) => {
		if (!fg('townsquare-enable-native-jira-goals-page')) {
			// When feature is disabled, return empty props
			// Component will show fallback (JiraConnectProjectApp)
			return {
				queries: {},
				extraProps: {},
			};
		}

		// Only preload LinkedGoals query when feature is enabled
		const { projectKey } = match.params;

		return {
			queries: {
				linkedGoalsQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters: linkedGoalsQueryParameters,
					variables: {
						projectKey,
						cloudId,
						first: 15,
						after: null,
					},
				},
			},
			extraProps: {
				cloudId,
				projectKey: projectKey ?? undefined,
			},
		};
	},
});
